import { render, staticRenderFns } from "./HeartRecord.vue?vue&type=template&id=4a0c66a0&scoped=true&"
import script from "./HeartRecord.vue?vue&type=script&lang=js&"
export * from "./HeartRecord.vue?vue&type=script&lang=js&"
import style0 from "./HeartRecord.vue?vue&type=style&index=0&id=4a0c66a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c66a0",
  null
  
)

export default component.exports